<h4 _ngcontent-mki-c5="" class="page-title"><i class="fas fa-mail-bulk"></i> Marketing </h4>

<!-- Seção de informações do WhatsApp para campanhas -->
<div class="whatsapp-info-header" *ngIf="numeroWhatsappCampanhas">
  <div class="whatsapp-header-card">
    <div class="whatsapp-header-content">
      <div class="whatsapp-header-icon">
        <i class="fab fa-whatsapp"></i>
      </div>
      <div class="whatsapp-header-details">
        <span class="whatsapp-header-title">Número para Campanhas</span>
        <div class="whatsapp-header-info">
          <span class="whatsapp-header-number">{{numeroWhatsappCampanhas.numero | tel}}</span>
          <span class="whatsapp-header-type"
                [class.type-principal]="numeroWhatsappCampanhas.tipo === 'Principal'"
                [class.type-campanhas]="numeroWhatsappCampanhas.tipo === 'Campanhas'"
                [class.type-both]="numeroWhatsappCampanhas.isPrincipal && numeroWhatsappCampanhas.tipo === 'Campanhas'"
                kendoTooltip
                [title]="numeroWhatsappCampanhas.isPrincipal && numeroWhatsappCampanhas.tipo === 'Campanhas' ?
                         'Este número é usado tanto para atendimento quanto para campanhas' :
                         numeroWhatsappCampanhas.tipo === 'Principal' ?
                         'Número principal da empresa, usado para campanhas por padrão' :
                         'Número específico configurado para envio de campanhas'">
            {{obtenhaTextoTipoNumero()}}
          </span>
        </div>
      </div>
      <div class="whatsapp-header-status">
        <i class="fas fa-check-circle" kendoTooltip title="Número configurado e pronto para envio"></i>
      </div>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-body">
    <button type="button" class="btn btn-blue   btn-lg  waves-effect waves-light" (click)="novaCampanha()">
      <i class="fas fa-mail-bulk"></i> Nova Campanha
    </button>
    <button type="button" class="btn btn-outline-blue btn-lg waves-effect waves-light ml-2" (click)="novaCampanhaTemplate()">
      <img src="/assets/icons/campanha-api-oficial.png" class="campanha-api-oficial-btn-icon" alt="">
      Nova campanha por template
    </button>

    <div class="mt-3">
      <kendo-tabstrip class="nav-bordered" id="tabs" name="tabs" (tabChange)="selecionouTipoDeCampanha($event)">
        <kendo-tabstrip-tab [id]="tipoDeEnvio.id" [title]="tipoDeEnvio.nome" *ngFor="let tipoDeEnvio of tiposDeEnvio" [selected]="tipoDeEnvio.id === this.filtroSelecionado">
          <ng-template kendoTabContent>
            <div class="k-i-loading ml-1 mr-1" style="font-size: 40px;height: 400px;" *ngIf="carregando"></div>
            <div *ngIf="campanhas.length == 0">
              <div class="justify-content-center text-center">
              <p><i class="fas fa-exclamation-triangle" style="font-size: 100px;color: #faa597;"></i>
              </p>
              <span style="font-size: 26px;">Você não tem campanhas ainda!</span>
              </div>
            </div>

            <div class="mt-1" *ngFor="let campanha of campanhas" style="padding-left: 10px;">
              <app-exibir-campanha [campanha]="campanha"></app-exibir-campanha>
            </div>
          </ng-template>

        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
  </div>
</div>
